import { Tooltip, IconButton, IconButtonProps } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

export interface RiskIconProps {
  disabled?: boolean;
  title: string;
  color?: IconButtonProps['color'];
}
export function RiskIcon({ title, disabled = false, color = 'inherit', ...rest }: RiskIconProps) {
  return (
    <Tooltip title={title} arrow>
      <IconButton
        data-testid="risk"
        disabled={disabled}
        color={color}
        aria-label="statusRisk"
        {...rest}
      >
        <WarningIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}

export default RiskIcon;
